import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../../Hoc/AdminLayout';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import { firebasePosts } from '../../../firebase';
import { firebaseLooper, reverseArray } from '../../ui/misc';

class AdminMatches extends Component {

    state = {
        isloading: true,
        matches:[]
    }

    componentDidMount(){
        firebasePosts.once('value').then(snapshot=>{
            const matches = firebaseLooper(snapshot);

            this.setState({
                isloading: false,
                matches:reverseArray(matches)
            })            

        });
    }


    render() {
        return (
            <AdminLayout>
                <div>
                    <Paper>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>promulgator</TableCell>
                                    <TableCell>Address</TableCell>
                                    <TableCell>Job Title</TableCell>
                                    <TableCell>Salary</TableCell>
                                    <TableCell>Position</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { this.state.matches ?
                                    this.state.matches.map((match,i)=>(
                                        <TableRow key={i}>
                                            <TableCell>
                                                {match.username}
                                            </TableCell>
                                            <TableCell>
                                                {match.address}
                                            </TableCell>
                                            <TableCell>
                                                {match.job_title}
                                            </TableCell>
                                            <TableCell>
                                                {match.salary}
                                            </TableCell>
                                            <TableCell>
                                                {match.latitude},{match.longitude}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    :null
                                }
                            </TableBody>
                        </Table>
                    </Paper>
                    <div className="admin_progress">
                        { this.state.isloading ?
                            <CircularProgress thickness={7} style={{color:'#98c5e9'}}/>
                            :''
                        }
                    </div>
                </div>
            </AdminLayout>
        );
    }
}

export default AdminMatches;


// WEBPACK FOOTER //
// ./src/Components/admin/matches/index.js